import styled from "styled-components";

export const CMMetrics = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 1.5rem 0 1rem;
    gap:15px;
  
    
    & .ContainerPlatformmIcon{
        justify-content: flex-start;
        align-items: center;
        gap: 10px;
    }
   

    @media (max-width: 1023px) {
      order: 1!important;
      min-height: 60px;
      width: 100%!important;
    }

    & .metric-container {
        @media (max-width: 1023px) {
            margin: auto !important;
        }
             @media (max-width: 600px) {
            font-size: 12px;
        }
    }

    & .youtube {
        width: 30px;
        height: 24px;
    }

    & > div {
        display: flex;
        align-items: center;                
        height: 100%;

        svg {
            width: ${(props) => props.theme.fontSizes.h3};
            height: ${(props) => props.theme.fontSizes.h3};
        }

        & > div {
            margin: 0 .3rem;                  
            text-align: left;            
            height: 100%;
            & h5 {
                margin: 0;
                font-weight: 400;
                margin-bottom: -${(props) => props.theme.spacers["1"]};
            }

            & span {
                font-size: 12px;
                margin: 0;
                color: ${(props) => props.theme.palette.gray["800"]};
                font-weight: 400;
                white-space: nowrap;
            }
        }
    }

    @media ${(props) => props.theme.breakpoints.lg} {
        justify-content: flex-start;

        & > div {
            margin-right: ${(props) => props.theme.spacers["6"]};
        }
    }

    @media ${(props) => props.theme.breakpoints.sm} {
        flex-direction: column;
        align-items: flex-start;

        & > div {
            margin-right: 0;
        }
    }
          & .ContainerPlatformmIconSymbolView{
        display:flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        gap: 10px;
    }
          & .metric-containerSymbolView {
          flex-wrap:wrap;
        @media (max-width: 1023px) {
            margin: auto;
        }
             @media (max-width: 600px) {
            font-size: 12px;
        }
    }
`;